import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyBK5oQ9211KxcTuc9SSsaleYEMe0NLFIM8',
  authDomain: 'myroomsai.firebaseapp.com',
  projectId: 'myroomsai',
  storageBucket: 'myroomsai.firebasestorage.app',
  messagingSenderId: '687163206284',
  appId: '1:687163206284:web:25e1875ae3a84f7ca9e9a9',
  measurementId: 'G-TVPG22F2H9',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Analytics is only available in supported browser environments.
export const analyticsPromise = isSupported().then((supported) =>
  supported ? getAnalytics(app) : null
);
